export enum FilterMode {
  TEXT_MODE,
  NUMBER_MODE,
  DATE_MODE,
  BOOL_MODE
}
